/*
 * @fileOverView Filter component definition
 *
 * This isn't demonstrated within Fractal because there's no back-end to
 * interact with.
 */

import Vue from 'vue';

/**
 * [Filter Vue]
 * @type {class}
 */
Vue.component('filter-vue', {
  props: [
    'filterName',
    'filtersId'
  ],

  data: function() {
    return {
      filtersExternalValues: {},
      filtersValues: {}
    }
  },

  mounted() {
    // Tracks values of all filters. Used to change visibility of one filter per
    // the data of another. Subscribing and this.$set are needed in order to
    // react to all object property changes.
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'filters/setValue' && mutation.payload.id === this.filtersId) {
        this.$set(this.filtersValues, mutation.payload.name, mutation.payload.value);
      }
      else if (mutation.type === 'filters/setExternalValue') {
        this.$set(this.filtersExternalValues, mutation.payload.name, mutation.payload.value);
      }
    })
  },

  methods: {
    /**
     * Reports to the Vuex store when a checkbox filter changes.
     *
     * @param  {Boolean} selectedValue The checkbox's reported value.
     * @param  {Object} el             The checkbox element.
     */
    checkboxChanged: function (selectedValue, el) {
      this.$store.dispatch('filters/setValue', {
        id: this.filtersId,
        name: this.filterName,
        value: selectedValue
      });
    },

    /**
     * Reports to the Vuex store when a dropdown filter changes.
     *
     * @param  {Number} selectedIndex The index of selected dropdown item.
     * @param  {String} selectedValue The value of the selected dropdown item.
     * @param  {Object} el            The dropdown element.
     */
    dropdownChanged: function (selectedIndex, selectedValue, el) {
      // The first option is the default and should reset/clear the value.
      if (selectedIndex === 0) {
        selectedValue = '';
      }

      this.$store.dispatch('filters/setValue', {
        id: this.filtersId,
        name: this.filterName,
        value: selectedValue
      });
    },

    /**
     * Reports to the Vuex store when a search pill filter is submitted.
     *
     * @param  {Number} submittedValue The value that was submitted
     * @param  {Object} el             The pill element.
     */
    searchPillSubmitted: function (submittedValue, el) {
      this.$store.dispatch('filters/setValue', {
        id: this.filtersId,
        name: this.filterName,
        value: submittedValue
      });
    },

    /**
     * Reports to the Vuex store when a slider filter value changes.
     *
     * @param  {Number} minValue The current minimum value of the slider.
     * @param  {Number} maxValue The current maximum value of the slider.
     * @param  {Object} el       The slider element.
     */
    sliderChanged: function (minValue, maxValue, el) {
      const value = minValue && maxValue ? minValue + '-' + maxValue : false;

      this.$store.dispatch('filters/setValue', {
        id: this.filtersId,
        name: this.filterName,
        value: value
      });
    }
  }
})
